import { Slider as MUISlider, SliderProps } from "@mui/material";

export const Slider = ({ classes, ...props }: SliderProps) => {
  return (
    <MUISlider
      classes={{
        rail: "bg-lds-surface-strong",
        thumb: "bg-lds-element-primary",
        track: "bg-lds-element-primary",
        ...classes,
      }}
      {...props}
    />
  );
};
